import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const LNBAccount = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="account_info">
      {children}
    </div>
  );
});

LNBAccount.displayName = 'LNBAccount';

export default LNBAccount;
